import QualityMetricSection from './QualityMetricSection';

export default QualityMetricSection;
